unable to read source [project]/packages/src/components/icons/MaterialIcon.tsx